const icon = require('vue-svgicon');
icon.register({
    'cart': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 20',
        data: `<path pid="0" d="M16 20H0V0h16v20zM1 19h14V1H1v18z"/><path pid="1" d="M4.1 4H3c0 2.8 2.2 5 5 5s5-2.2 5-5h-1.1c0 2.2-1.7 3.9-3.9 3.9S4.1 6.2 4.1 4z"/>`,
    },
});
